<template>
  <div>
    <div class="wrapper">
      <breadcrumb
        :crumbs="[$t('menu.tracksOrder'), $t('text.list')]"
      ></breadcrumb>
    </div>
    <narrow
      :narrows="narrows"
      :init-filter="initFilter"
      @narrowSelect="narrowSelect"
    />
    <div class="search with-narrows">
      <el-form
        :inline="true"
        @submit.native.prevent="search"
        :model="searchForm"
        size="small"
      >
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.keyword"
            :placeholder="$t('placeholder.serialNoInnerSerialNo')"
          />
        </el-form-item>
        <customer-search
          v-model="searchForm"
          fieldId="customerId"
          fieldName="customerName"
        />
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.productNo"
            :placeholder="$t('placeholder.productNoCustomerProductNo')"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-select
            v-model="searchForm.categoryId"
            :placeholder="$t('product.category')"
            size="small"
            filterable
            clearable
          >
            <el-option
              v-for="category in categories"
              :key="category.id"
              :label="category.name"
              :value="category.id"
            />
          </el-select>
        </el-form-item>
        <date-range
          v-model="searchForm"
          type="datetime"
          field="createAt"
          :start-placeholder="$t('rules.startAt', [$t('text.createAt')])"
          :end-placeholder="$t('rules.endAt', [$t('text.createAt')])"
        />
        <date-range
          v-model="searchForm"
          type="datetime"
          field="handOver"
          :start-placeholder="$t('rules.startAt', [$t('text.handOverAt')])"
          :end-placeholder="$t('rules.endAt', [$t('text.handOverAt')])"
        />
        <el-form-item>
          <el-input
            v-model.trim="searchForm.handle"
            :placeholder="$t('text.handle')"
            size="small"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            native-type="submit"
          />
        </el-form-item>
      </el-form>
    </div>
    <div class="wrapper table-area">
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="全部" name="0"> </el-tab-pane>
        <el-tab-pane
          :label="factory.name"
          :name="factory.id + ''"
          v-for="factory of mesAuthFactories"
          :key="factory.id"
        >
        </el-tab-pane>
      </el-tabs>
      <sticky
        :sticky-top="50"
        :viewport="1024"
        :is-rem="false"
        style="min-height: 52px"
      >
        <vxe-toolbar ref="recordsToolbar" custom zoom class="table-toolbar">
          <template v-slot:buttons>
            <span class="float-right grey font10 mgl10">
              *总在产件数如果大于各工序件数之和，则多出来的在工序间交接
            </span>
          </template>
        </vxe-toolbar>
      </sticky>
      <vxe-table
        :data="records"
        @sort-change="sortRecords"
        :sort-config="{ remote: true }"
        ref="recordsTable"
        class="recordsTable"
        :cell-class-name="tableCellClassName"
        size="mini"
        id="pendingsTable"
        row-id="id"
        :loading="loading"
        resizable
        round
        highlight-hover-row
        auto-resize
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column
          field="images"
          :title="$t('product.images')"
          width="80"
          align="center"
          fixed="left"
        >
          <template v-slot="{ row }">
            <thumbnail :images="row.images" :height="46"></thumbnail>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="serialNo"
          :title="$t('text.serialNo')"
          width="130"
          lign="center"
          fixed="left"
        >
          <template v-slot="{ row }">
            <small v-if="row.hurry" class="red">
              ({{ $t("order.hurrySimple") }})
            </small>
            <a @click="showRecord(row)">
              <s v-if="row.retrieveAt != null">
                <raw-html-limit-number
                  :content="row.serialNo"
                  :number="12"
                  cut="prepend"
                />
              </s>
              <span v-if="row.retrieveAt == null">
                <s v-if="row.jyOrderCancelAt != null" class="grey">
                  <raw-html-limit-number
                    :content="row.serialNo"
                    :number="12"
                    cut="prepend"
                  />
                </s>
                <span v-if="row.jyOrderCancelAt == null">
                  <raw-html-limit-number
                    :content="row.serialNo"
                    :number="12"
                    cut="prepend"
                  />
                </span>
              </span>
            </a>
            <div>
              <state-label :state="row.workflowState">
                {{ $t("mesOrderStates." + row.workflowState) }}
              </state-label>
              <span v-if="row.pauseAt != null" class="orange font10">
                {{ $t("text.stop") }}
              </span>
              <a
                v-if="row.sizeTemplate"
                class="font10"
                :href="row.sizeTemplate"
                target="_blank"
              >
                {{ $t("orderMes.sizeTemplate") }}
              </a>
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="productNo"
          :title="$t('product.productNo')"
          width="100"
          lign="center"
          fixed="left"
        >
          <template v-slot="{ row }">
            {{ row.productNo }}
            <div class="font10">{{ row.color }} {{ row.size }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="processingQty"
          :title="'在产件数'"
          width="80"
          align="center"
          fixed="left"
        />
        <vxe-table-column
          v-for="phase of showPhases"
          :key="phase.id"
          :title="phase.name"
          width="70"
          align="center"
          v-bind="phase"
          :field="phase.name"
          show-header-overflow
          show-overflow="title"
        >
          <template v-slot="{ row }">
            <span v-if="computeCurrentPhase(row, phase) != null">
              <span v-if="computeCurrentPhaseCount(row, phase) != null">{{
                computeCurrentPhaseCount(row, phase).totalQty
              }}</span>
              <span v-else class="font10">0</span>
            </span>
            <span v-else>--</span>
          </template>
        </vxe-table-column>
      </vxe-table>
      <div class="flex flex-between pager">
        <div class="selected-qty-tips">
          选中了
          <span class="strong">{{ selectRecordQty }} </span>条记录
        </div>
        <div>
          <vxe-pager
            size="small"
            :loading="false"
            :background="false"
            :current-page="pager.currentPage"
            :page-size="pager.pageSize"
            :total="pager.total"
            :layouts="pagerConfig.layouts"
            :page-sizes="pagerConfig.pageSizes"
            @page-change="changePager"
          ></vxe-pager>
        </div>
      </div>
    </div>
    <!-- ======== -->
    <drawer
      :title="$t('text.view')"
      :visible.sync="show"
      size="900px"
      direction="rtl"
      :wrapper-closable="false"
      :destroy-on-close="true"
    >
      <show :uuid="currentRowUuid" :id="currentRowId" />
    </drawer>
  </div>
</template>

<script>
import axios from "axios";
import { page, table } from "@/utils/mixins.js";
import Util from "@/utils/index.js";
import Thumbnail from "@/components/Thumbnail";
import RawHtmlLimitNumber from "@/components/RawHtmlLimitNumber";
import DateRange from "@/components/DateRange";
import TinymceEditor from "@/components/TinymceEditor";
import CustomerSearch from "@/components/CustomerSearch";

import OrderMes from "@/api/orderMes.js";
import Brand from "@/api/brand.js";
import Category from "@/api/category.js";
import Enumeration from "@/api/enumeration.js";
import Factory from "@/api/factory.js";
import UserFactory from "@/api/userFactory.js";
import Phase from "@/api/phase.js";
import Show from "@/views/mes/orders/show.vue";
import PagerConfig from "@/config/pager.js";

export default {
  mixins: [
    page,
    table.pager,
    table.narrow,
    table.search,
    table.checker,
    table.sorter,
    table.basic,
  ],
  components: {
    Thumbnail,
    RawHtmlLimitNumber,
    DateRange,
    TinymceEditor,
    Show,
    CustomerSearch,
  },

  data() {
    return {
      Util: Util,
      sorter: {
        sortBy: "orders_id",
        sortIndicator: "desc",
      },
      narrows: [
        [
          {
            label: this.$t("order.nearRange"),
            items: OrderMes.nearRange,
          },
          {
            label: this.$t("order.passRange"),
            items: OrderMes.passRange,
          },
        ],
        [
          {
            label: this.$t("text.workflowState"),
            items: OrderMes.states_all.map((s) => {
              return {
                label: this.$t("mesOrderStates." + s),
                key: s,
                condition: { workflowStates: [s] },
              };
            }),
          },
          {
            label: this.$t("text.special"),
            items: [
              {
                label: this.$t("order.hurry"),
                key: "hurryYes",
                condition: { hurry: "yes" },
              },
              {
                label: this.$t("action.retrieve"),
                key: "yes",
                condition: { retrieve: "yes" },
              },
              {
                label: this.$t("orderMes.customerCancel"),
                key: "customerCancel",
                condition: { cancelType: "customer" },
              },
            ],
          },
        ],
      ],
      initFilter: null,
      searchForm: {
        keyword: null,
        customerId: null,
        customerName: null,
        createAtStratAt: null,
        createAtEndAt: null,
        handOverStartAt: null,
        handOverEndAt: null,
        handle: null,
        productNo: null,
        categoryId: null,
      },
      categories: [],
      brands: [],
      phases: [],
      showPhases: [],
      show: false,
      currentRowId: null,
      currentRowUuid: null,
      factories: [],
      userFactories: [],
      mesAuthFactories: [],

      showProductInfoDF: false,
      activeName: "0",
    };
  },
  created() {
    const self = this;
    this.$nextTick(() => {
      // 手动将表格和工具栏进行关联
      this.$refs.recordsTable.connect(this.$refs.recordsToolbar);
    });
    axios
      .all([
        Category.findByTenantId(),
        Brand.findByTenantId(),
        Enumeration.findByType("group"),
        Factory.findByTenantId(),
        UserFactory.findByUserId(self.Permit.currentUser().id),
        Phase.findByTenantId(),
      ])
      .then(
        axios.spread(function (
          categories,
          brands,
          groups,
          factories,
          userFactories,
          phases
        ) {
          if (categories.status === 200) {
            self.categories = categories.data;
          } else {
            self.sysError();
          }
          if (brands.status === 200) {
            self.brands = brands.data;
          } else {
            self.sysError();
          }
          if (groups.data.code === 200) {
            self.groups = JSON.parse(groups.data.entity.itemsJson);
          } else {
            self.sysError();
          }
          if (factories.status === 200) {
            self.factories = factories.data;
          } else {
            self.sysError();
          }
          if (userFactories.status == 200) {
            self.userFactories = userFactories.data;

            if (self.Permit.currentUser().admin === true) {
              self.mesAuthFactories = self.factories;
            } else {
              const userFactoryIds = self.userFactories.map((u) => u.factoryId);
              self.mesAuthFactories = self.factories.filter((f) =>
                userFactoryIds.includes(f.id)
              );
            }
            self.narrowsFactoriesBrandsGroups();
          } else {
            self.sysError();
          }
          if (phases.status === 200) {
            self.phases = phases.data;
            self.showPhases = phases.data;
          } else {
            self.sysError();
          }
        })
      );
  },
  methods: {
    handleClick(tab, event) {
      this.pager.currentPage = 1;
      this.pager.pageSize = PagerConfig.normal.defaultPageSize;
      this.searchForm.factoryId = null;
      if (Number(this.activeName) == 0) {
        this.showPhases = this.phases;
      } else {
        this.searchForm.factoryId = Number(this.activeName);
        let factoryObj = this.factories.find(
          (f) => f.id == Number(this.activeName)
        );
        this.showPhases = factoryObj.factoryPhases.map((f) => {
          return {
            id: f.phaseId,
            name: f.phaseName,
            tenantId: null,
            deletedAt: null,
            sequence: f.sequence,
            phaseGroupId: null,
            phaseGroupName: null,
            factoryPhases: null,
          };
        });
      }
      this.loadData();
    },
    computeCurrentPhase(row, currentPhase) {
      if (row.phaePlans.length !== 0) {
        const currentPhasePlans = row.phaePlans.filter(
          (p) => p.phaseId === currentPhase.id
        );
        if (currentPhasePlans.length !== 0) {
          return currentPhasePlans[0];
        }
        return null;
      }
      return null;
    },
    computeCurrentPhaseCount(row, currentPhase) {
      if (row.phaseCounts.length !== 0) {
        const currentPhaseCount = row.phaseCounts.filter(
          (p) => p.phaseId === currentPhase.id
        );
        if (currentPhaseCount.length !== 0) {
          return currentPhaseCount[0];
        }
        return null;
      }
      return null;
    },

    cellClickShowProduct(row) {
      this.record = row;
      this.showProductInfoDF = true;
    },

    //==
    narrowsFactoriesBrandsGroups() {
      this.narrows.push([
        // {
        //   label: this.$t("menu.factories"),
        //   items: this.mesAuthFactories.map((factory) => {
        //     return {
        //       label: factory.name,
        //       key: factory.id,
        //       condition: { factoryId: factory.id },
        //     };
        //   }),
        // },
        {
          label: this.$t("product.brand"),
          items: this.brands.map((brand) => {
            return {
              label: brand.name,
              key: brand.name,
              condition: { brand: brand.name },
            };
          }),
        },
        {
          label: this.$t("action.group"),
          items: this.groups.map((group) => {
            return {
              label: group,
              key: group,
              condition: { group: group },
            };
          }),
        },
      ]);
    },

    showRecord(row) {
      this.currentRowUuid = row.uuid;
      this.currentRowId = row.id;
      this.show = true;
    },
    //======
    dataProvider(params) {
      return OrderMes.trackingSearch(params);
    },
    tableCellClassName({ row, column, rowIndex, columnIndex }) {
      if (
        columnIndex < 4 &&
        ["newly", "processing"].includes(row.workflowState) &&
        row.handOverAt !== null
      ) {
        if (
          Util.dateDiff(row.handOverAt, new Date()) <=
            this.Permit.currentTenant().config.nearDays &&
          Util.dateDiff(row.handOverAt, new Date()) > 0
        ) {
          return "warning-row";
        }
        if (Util.dateDiff(row.handOverAt, new Date()) <= 0) {
          return "special-row";
        }
      }
    },
  },
};
</script>
<style>
.color-explain {
  height: 10px;
  width: 40px;
  border: 1px solid #eee;
  margin-top: 7px;
  margin-right: 5px;
}
.bg-green {
  background: #67c23a;
  color: #fff;
}
.bg-orange {
  background: #eb9e05;
  color: #fff;
}
.bg-grey {
  background: #fafafa;
}

.bg-green-delay {
  background: #67c23a;
  color: #fff;
}
.bg-orange-delay {
  background: #eb9e05;
  color: #fff;
}
.bg-grey-delay {
  background: #fafafa;
}

.warning-row {
  background: rgba(248, 218, 174, 1);
}

.special-row {
  background: rgba(255, 190, 194, 1);
}
/* 
.vxe-table.size--mini .vxe-body--column:not(.col--ellipsis),
.vxe-table.size--mini .vxe-footer--column:not(.col--ellipsis),
.vxe-table.size--mini .vxe-header--column:not(.col--ellipsis) {
  padding: 0px 0;
}

.vxe-table .vxe-cell {
  white-space: pre-line;
  word-break: break-all;
  padding-left: 2px;
  padding-right: 2px;
  font-size: 12px;
} */
</style>
